import React from 'react'
import queryString from 'query-string'
import styles from '../../styles/login.css'
import CopyrightStatement from '../../components/CopyrightStatement'
import Loading from '../../components/Loading'
import KardiaProLogo from 'static/images/kardia_pro_logo.svg'

class AppOrchard extends React.PureComponent {
  UNSAFE_componentWillMount() {
    const ssoParams = queryString.parse(window.location.search)
    const { code, sso } = ssoParams
    console.log(code, sso)
    this.props.handleLogin(code, sso)
  }

  render() {
    return (
      <div data-page="sso-login" className={styles.ssoLogin}>
        <div className={styles.loginOuterCont}>
          <div className={styles.loginBox}>
            <section className={styles.header}>
              <div className={styles.logo}>
                <KardiaProLogo />
              </div>
            </section>
            <section className={styles.content}>
              <div className={styles.contentInner}>
                <div className={styles.preambleSso}>
                  <h4>Logging In</h4>
                  <Loading size="large" />
                </div>
              </div>
            </section>
            <section className={styles.footer}>
              <CopyrightStatement />
            </section>
          </div>
        </div>
      </div>
    )
  }
}

export default AppOrchard



// WEBPACK FOOTER //
// ./src/legacy/pages/AppOrchard/AppOrchard.jsx